(function () {
  var DEBUG = true;
  var NAME_MAX_LENGTH = 40;

  function log() {
    if (!DEBUG) return;
    try {
      console.log.apply(console, ["[bundly-personalization]"].concat(Array.prototype.slice.call(arguments)));
    } catch (e) {}
  }

  function normalizeProductId(value) {
    var raw = String(value || "").trim();
    if (!raw) return "";
    var gidMatch = raw.match(/Product\/(\d+)/i);
    if (gidMatch) return gidMatch[1];
    var digits = raw.match(/(\d{8,})/);
    if (digits) return digits[1];
    return raw;
  }

  function normalizeVariantId(value) {
    var raw = String(value || "").trim();
    if (!raw) return "";
    var gidMatch = raw.match(/ProductVariant\/(\d+)/i);
    if (gidMatch) return gidMatch[1];
    var digits = raw.match(/(\d{8,})/);
    if (digits) return digits[1];
    return raw;
  }

  function toIdSet(list) {
    var out = new Set();
    (list || []).forEach(function (item) {
      var id = normalizeProductId(item);
      if (id) out.add(id);
    });
    return out;
  }

  function readConfig() {
    var dataEl = document.getElementById("bundly-pack-rules");
    if (!dataEl) return null;

    try {
      var parsed = JSON.parse(dataEl.textContent || "{}");
      var config = {
        nameOnly: toIdSet(parsed.name_only),
        numberOnly: toIdSet(parsed.number_only),
        nameAndNumber: toIdSet(parsed.name_and_number),
      };
      log("config", {
        nameOnly: Array.from(config.nameOnly),
        numberOnly: Array.from(config.numberOnly),
        nameAndNumber: Array.from(config.nameAndNumber),
      });
      return config;
    } catch (error) {
      console.error("[bundly-personalization] Error leyendo configuracion", error);
      return null;
    }
  }

  function getLiveContext() {
    var root = document.querySelector("#bundly__details") || document.querySelector(".bundly__details");
    if (!root) return null;
    var form =
      root.closest("form") ||
      document.querySelector("form.bundly__form") ||
      document.querySelector('form[action*="/cart/add"]');
    if (!form) return null;
    return { root: root, form: form };
  }

  function getRuleForProduct(productId, config) {
    var id = normalizeProductId(productId);
    if (!id) return null;
    if (config.nameAndNumber.has(id)) return { requiresName: true, requiresNumber: true };
    if (config.numberOnly.has(id)) return { requiresName: false, requiresNumber: true };
    if (config.nameOnly.has(id)) return { requiresName: true, requiresNumber: false };
    return null;
  }

  function ensureHiddenInput(parent, name, value, formId) {
    var input = parent.querySelector('input[name="' + CSS.escape(name) + '"]');
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      if (formId) input.setAttribute("form", formId);
      parent.appendChild(input);
    }
    input.value = value;
  }

  var valuesByComponent = new Map();

  function getSelectedCards(root) {
    var selected = root.querySelectorAll(
      '.bundly__component_grid_item[data-variant-selected="true"], bundly-product-component-card[data-variant-selected="true"]'
    );
    if (selected.length) return Array.prototype.slice.call(selected);
    return Array.prototype.slice.call(
      root.querySelectorAll(".bundly__component_grid_item, bundly-product-component-card.bundly__component_grid_item")
    );
  }

  function getMountNode(card) {
    return (
      card.querySelector(".bundly__component_info") ||
      card.querySelector(".bundly__component_heading") ||
      card
    );
  }

  function readValuesFromDom(root) {
    root.querySelectorAll("[data-bundly-personalization-name]").forEach(function (input) {
      var componentIndex = String(input.getAttribute("data-bundly-personalization-name") || "");
      if (!componentIndex) return;
      var prev = valuesByComponent.get(componentIndex) || { name: "", number: "" };
      valuesByComponent.set(componentIndex, {
        name: String(input.value || "").slice(0, NAME_MAX_LENGTH),
        number: prev.number,
      });
    });
    root.querySelectorAll("[data-bundly-personalization-number]").forEach(function (input) {
      var componentIndex = String(input.getAttribute("data-bundly-personalization-number") || "");
      if (!componentIndex) return;
      var prev = valuesByComponent.get(componentIndex) || { name: "", number: "" };
      var normalized = String(input.value || "").replace(/\D/g, "").slice(0, 2);
      valuesByComponent.set(componentIndex, {
        name: prev.name,
        number: normalized,
      });
    });
  }

  function getCardTitle(card) {
    var titleEl = card.querySelector(".bundly__component_title");
    return titleEl ? titleEl.textContent.replace(/\s+/g, " ").trim() : "Componente";
  }

  function buildPersonalizationPayload(config) {
    var ctx = getLiveContext();
    if (!ctx) {
      return {
        byVariantId: {},
        byProductId: {},
        byComponentIndex: {},
        globalNameValue: "",
        globalNumberValue: "",
        summaryValue: "",
        rows: [],
      };
    }

    readValuesFromDom(ctx.root);

    var byVariantId = {};
    var byProductId = {};
    var byComponentIndex = {};
    var globalNames = [];
    var globalNumbers = [];
    var detailRows = [];

    getSelectedCards(ctx.root).forEach(function (card) {
      var productId = normalizeProductId(card.getAttribute("data-product-id"));
      var variantId = normalizeVariantId(card.getAttribute("data-selected-variant-id"));
      var componentIndex = String(card.getAttribute("data-component-index") || "");
      if (!productId || !componentIndex) return;

      var rule = getRuleForProduct(productId, config);
      var selectedValue = valuesByComponent.get(componentIndex) || { name: "", number: "" };
      var name = String(selectedValue.name || "").trim().slice(0, NAME_MAX_LENGTH);
      var number = String(selectedValue.number || "").trim();
      var type = rule ? (name && number ? "ambos" : name ? "nombre" : number ? "dorsal" : "ninguno") : "ninguno";
      var label = getCardTitle(card);

      if (name) globalNames.push(label + ": " + name);
      if (number) globalNumbers.push(label + ": " + number);
      if (rule && type !== "ninguno") {
        detailRows.push(
          label + " -> " + type + (name ? " | Nombre: " + name : "") + (number ? " | Dorsal: " + number : "")
        );
      }

      var props = {
        "Personalizacion Nombre": name,
        "Personalizacion Dorsal": number,
        "Personalizacion Tipo": type,
      };

      byComponentIndex[componentIndex] = props;
      byProductId[productId] = props;
      if (variantId) byVariantId[variantId] = props;
    });

    return {
      byVariantId: byVariantId,
      byProductId: byProductId,
      byComponentIndex: byComponentIndex,
      globalNameValue: globalNames.join(" | "),
      globalNumberValue: globalNumbers.join(" | "),
      summaryValue: detailRows.join(" || "),
      rows: detailRows,
    };
  }

  function mergeItemProperties(item, localProps, payload) {
    if (!item || typeof item !== "object") return item;
    item.properties = Object.assign({}, item.properties || {}, localProps || {}, {
      "Pedido Nombre Global": payload.globalNameValue,
      "Pedido Dorsal Global": payload.globalNumberValue,
      "Personalizacion Resumen": payload.summaryValue,
    });
    return item;
  }

  function enrichCartJson(body, config) {
    var payload = buildPersonalizationPayload(config);
    if (!body || typeof body !== "object") return body;

    if (Array.isArray(body.items)) {
      body.items = body.items.map(function (item) {
        var variantId = normalizeVariantId(item.id || item.variant_id || "");
        var localProps = payload.byVariantId[variantId] || {};
        return mergeItemProperties(item, localProps, payload);
      });
      return body;
    }

    if (body.id || body.variant_id) {
      var singleVariantId = normalizeVariantId(body.id || body.variant_id);
      return mergeItemProperties(body, payload.byVariantId[singleVariantId] || {}, payload);
    }

    return body;
  }

  function isCartAddUrl(url) {
    var value = String(url || "");
    return value.indexOf("/cart/add") !== -1;
  }

  function installCartIntercept(config) {
    if (window.__bundlyPersonalizationFetchPatched) return;
    window.__bundlyPersonalizationFetchPatched = true;

    var originalFetch = window.fetch;
    if (typeof originalFetch === "function") {
      window.fetch = function (input, init) {
        try {
          var url = typeof input === "string" ? input : input && input.url ? input.url : "";
          if (isCartAddUrl(url)) {
            var nextInit = init ? Object.assign({}, init) : {};
            var method = String(nextInit.method || (input && input.method) || "GET").toUpperCase();
            if (method === "POST" || method === "PUT") {
              var rawBody = nextInit.body;
              if (typeof rawBody === "string") {
                try {
                  var parsed = JSON.parse(rawBody);
                  nextInit.body = JSON.stringify(enrichCartJson(parsed, config));
                  log("intercept fetch JSON cart/add", nextInit.body);
                } catch (e) {
                  // Form-encoded body: leave as-is; form hidden inputs cover globals.
                  log("intercept fetch non-json body");
                }
              } else if (rawBody && typeof rawBody === "object" && !(rawBody instanceof FormData) && !(rawBody instanceof Blob)) {
                nextInit.body = JSON.stringify(enrichCartJson(rawBody, config));
                log("intercept fetch object cart/add", nextInit.body);
              }
            }
            return originalFetch.call(this, input, nextInit);
          }
        } catch (error) {
          log("fetch intercept error", error);
        }
        return originalFetch.apply(this, arguments);
      };
    }

    if (window.XMLHttpRequest && window.XMLHttpRequest.prototype) {
      var originalOpen = window.XMLHttpRequest.prototype.open;
      var originalSend = window.XMLHttpRequest.prototype.send;

      window.XMLHttpRequest.prototype.open = function (method, url) {
        this.__bundlyCartUrl = url;
        this.__bundlyCartMethod = method;
        return originalOpen.apply(this, arguments);
      };

      window.XMLHttpRequest.prototype.send = function (body) {
        try {
          if (isCartAddUrl(this.__bundlyCartUrl) && typeof body === "string") {
            try {
              var parsed = JSON.parse(body);
              body = JSON.stringify(enrichCartJson(parsed, config));
              log("intercept xhr JSON cart/add", body);
            } catch (e) {}
          }
        } catch (error) {
          log("xhr intercept error", error);
        }
        return originalSend.call(this, body);
      };
    }
  }

  function renderPersonalizationFields(config) {
    var ctx = getLiveContext();
    if (!ctx) return;

    var cards = getSelectedCards(ctx.root);
    log("render cards", {
      selectedCount: cards.length,
      productIds: cards.map(function (card) {
        return normalizeProductId(card.getAttribute("data-product-id"));
      }),
    });

    cards.forEach(function (card) {
      var productId = normalizeProductId(card.getAttribute("data-product-id"));
      var componentIndex = String(card.getAttribute("data-component-index") || "");
      if (!productId || !componentIndex) return;

      var rule = getRuleForProduct(productId, config);
      var mount = getMountNode(card);
      var existing = mount.querySelector(":scope > [data-bundly-personalization], [data-bundly-personalization]");

      // Avoid duplicating inside dialogs: only mount on the main card info.
      if (card.closest("dialog")) return;

      if (!rule) {
        if (existing && existing.closest(".bundly__component_info")) existing.remove();
        return;
      }

      if (existing) {
        var nameInput = existing.querySelector("[data-bundly-personalization-name]");
        var numberInput = existing.querySelector("[data-bundly-personalization-number]");
        var saved = valuesByComponent.get(componentIndex) || { name: "", number: "" };
        if (nameInput) nameInput.value = saved.name || "";
        if (numberInput) numberInput.value = saved.number || "";
        return;
      }

      var savedValues = valuesByComponent.get(componentIndex) || { name: "", number: "" };
      var wrap = document.createElement("div");
      wrap.dataset.bundlyPersonalization = "true";
      wrap.className = "bundly__personalization v-stack";
      wrap.style.display = "grid";
      wrap.style.gap = "8px";
      wrap.style.marginTop = "8px";
      wrap.style.paddingTop = "8px";
      wrap.style.borderTop = "1px solid rgb(var(--border-color) / 0.3)";

      if (rule.requiresName) {
        var labelName = document.createElement("label");
        labelName.textContent = "Nombre y apellidos";
        labelName.className = "text-sm";
        var inputName = document.createElement("input");
        inputName.type = "text";
        inputName.maxLength = NAME_MAX_LENGTH;
        inputName.value = savedValues.name || "";
        inputName.placeholder = "Ej. MARTIN GARCIA";
        inputName.className = "input";
        inputName.dataset.bundlyPersonalizationName = componentIndex;
        labelName.appendChild(inputName);
        wrap.appendChild(labelName);
      }

      if (rule.requiresNumber) {
        var labelNumber = document.createElement("label");
        labelNumber.textContent = "Dorsal";
        labelNumber.className = "text-sm";
        var inputNumber = document.createElement("input");
        inputNumber.type = "text";
        inputNumber.inputMode = "numeric";
        inputNumber.maxLength = 2;
        inputNumber.value = savedValues.number || "";
        inputNumber.placeholder = "Ej. 10";
        inputNumber.className = "input";
        inputNumber.dataset.bundlyPersonalizationNumber = componentIndex;
        labelNumber.appendChild(inputNumber);
        wrap.appendChild(labelNumber);
      }

      mount.appendChild(wrap);
    });
  }

  function syncLineItemProperties(config) {
    var ctx = getLiveContext();
    if (!ctx) return;

    var payload = buildPersonalizationPayload(config);

    // Fallback legacy DOM rows (Bundly antiguo).
    var selectedVariants = ctx.root.querySelectorAll(".bundly__selected_variant");
    selectedVariants.forEach(function (variantRow, index) {
      var componentIdInput = variantRow.querySelector('input[name*="[_bundly__component_id]"]');
      var lineIdInput = variantRow.querySelector('input[name*="[id]"]');
      if (!lineIdInput) return;

      var idxMatch = lineIdInput.name.match(/^items\[(\d+)\]\[id\]$/);
      if (!idxMatch) return;
      var lineIndex = idxMatch[1];
      var lineFormId = lineIdInput.getAttribute("form") || ctx.form.id;

      var componentIndex = "";
      if (componentIdInput) {
        var pieces = String(componentIdInput.value || "").split("|");
        componentIndex = pieces[1] || "";
      }
      if (!componentIndex) componentIndex = String(index);

      var localProps = payload.byComponentIndex[componentIndex] || {
        "Personalizacion Nombre": "",
        "Personalizacion Dorsal": "",
        "Personalizacion Tipo": "ninguno",
      };

      ensureHiddenInput(
        variantRow,
        "items[" + lineIndex + "][properties][Personalizacion Nombre]",
        localProps["Personalizacion Nombre"],
        lineFormId
      );
      ensureHiddenInput(
        variantRow,
        "items[" + lineIndex + "][properties][Personalizacion Dorsal]",
        localProps["Personalizacion Dorsal"],
        lineFormId
      );
      ensureHiddenInput(
        variantRow,
        "items[" + lineIndex + "][properties][Personalizacion Tipo]",
        localProps["Personalizacion Tipo"],
        lineFormId
      );
      ensureHiddenInput(
        variantRow,
        "items[" + lineIndex + "][properties][Pedido Nombre Global]",
        payload.globalNameValue,
        lineFormId
      );
      ensureHiddenInput(
        variantRow,
        "items[" + lineIndex + "][properties][Pedido Dorsal Global]",
        payload.globalNumberValue,
        lineFormId
      );
    });

    // Globals siempre en el form (Bundly Lit actual).
    ensureHiddenInput(ctx.form, "properties[Pedido Nombre Global]", payload.globalNameValue, ctx.form.id);
    ensureHiddenInput(ctx.form, "properties[Pedido Dorsal Global]", payload.globalNumberValue, ctx.form.id);
    ensureHiddenInput(ctx.form, "properties[Personalizacion Resumen]", payload.summaryValue, ctx.form.id);

    log("sync", {
      globalNameValue: payload.globalNameValue,
      globalNumberValue: payload.globalNumberValue,
      detailCount: payload.rows.length,
      values: Array.from(valuesByComponent.entries()),
      selectedVariantCount: selectedVariants.length,
      byVariantId: payload.byVariantId,
    });
  }

  function validateRequiredFields(config) {
    var ctx = getLiveContext();
    if (!ctx) return true;

    readValuesFromDom(ctx.root);

    var cards = getSelectedCards(ctx.root);
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.closest("dialog")) continue;
      var productId = normalizeProductId(card.getAttribute("data-product-id"));
      var componentIndex = String(card.getAttribute("data-component-index") || "");
      if (!productId || !componentIndex) continue;

      var rule = getRuleForProduct(productId, config);
      if (!rule) continue;

      var values = valuesByComponent.get(componentIndex) || { name: "", number: "" };
      if (rule.requiresName && !String(values.name || "").trim()) return false;
      if (rule.requiresNumber && !String(values.number || "").trim()) return false;
    }

    return true;
  }

  function init() {
    var config = readConfig();
    if (!config) {
      log("config vacia o invalida");
      return;
    }
    log("init");
    installCartIntercept(config);

    function refresh() {
      renderPersonalizationFields(config);
      syncLineItemProperties(config);
    }

    refresh();

    document.addEventListener("input", function (event) {
      var nameInput = event.target.closest("[data-bundly-personalization-name]");
      if (nameInput) {
        var componentIndexName = String(nameInput.getAttribute("data-bundly-personalization-name") || "");
        var prevName = valuesByComponent.get(componentIndexName) || { name: "", number: "" };
        var nameValue = String(nameInput.value || "").slice(0, NAME_MAX_LENGTH);
        nameInput.value = nameValue;
        valuesByComponent.set(componentIndexName, { name: nameValue, number: prevName.number });
        syncLineItemProperties(config);
        return;
      }

      var numberInput = event.target.closest("[data-bundly-personalization-number]");
      if (numberInput) {
        var componentIndexNumber = String(numberInput.getAttribute("data-bundly-personalization-number") || "");
        var normalized = String(numberInput.value || "").replace(/\D/g, "").slice(0, 2);
        numberInput.value = normalized;
        var prevNumber = valuesByComponent.get(componentIndexNumber) || { name: "", number: "" };
        valuesByComponent.set(componentIndexNumber, { name: prevNumber.name, number: normalized });
        syncLineItemProperties(config);
      }
    });

    document.addEventListener(
      "click",
      function (event) {
        var addToCartBtn = event.target.closest(".bundly__add_to_cart_button");
        if (!addToCartBtn) return;
        log("click add_to_cart");

        if (!validateRequiredFields(config)) {
          event.preventDefault();
          event.stopPropagation();
          alert("Completa Nombre y/o Dorsal antes de agregar el pack al carrito.");
          return;
        }
        refresh();
      },
      true
    );

    document.addEventListener(
      "submit",
      function (event) {
        var targetForm = event.target;
        if (!(targetForm instanceof HTMLFormElement)) return;
        if (!targetForm.querySelector("#bundly__details") && !targetForm.querySelector(".bundly__details")) return;

        log("submit bundly form", { formId: targetForm.id || "(sin id)" });

        if (!validateRequiredFields(config)) {
          event.preventDefault();
          event.stopPropagation();
          alert("Completa Nombre y/o Dorsal antes de agregar el pack al carrito.");
          return;
        }

        refresh();

        try {
          var fd = new FormData(targetForm);
          var entries = [];
          fd.forEach(function (value, key) {
            if (String(key).indexOf("properties") !== -1) entries.push([key, String(value)]);
          });
          log("FormData properties", entries);
          log("payload snapshot", buildPersonalizationPayload(config));
        } catch (e) {
          log("No se pudo leer FormData", e);
        }
      },
      true
    );

    document.addEventListener("htmx:afterSwap", function () {
      refresh();
    });

    document.addEventListener("htmx:afterSettle", function () {
      refresh();
    });

    document.addEventListener("bundly:afterLoadBundle", function () {
      refresh();
    });

    var ctx = getLiveContext();
    if (ctx && window.MutationObserver) {
      var observer = new MutationObserver(function (mutations) {
        var shouldRefresh = mutations.some(function (mutation) {
          if (!mutation.addedNodes || !mutation.addedNodes.length) return false;
          for (var i = 0; i < mutation.addedNodes.length; i++) {
            var node = mutation.addedNodes[i];
            if (!(node instanceof Element)) continue;
            if (node.matches && node.matches("[data-bundly-personalization]")) continue;
            if (node.querySelector && node.querySelector("[data-bundly-personalization]")) continue;
            if (
              node.matches &&
              (node.matches(".bundly__component_grid_item") ||
                node.matches("bundly-product-component-card") ||
                node.matches("bundly-product-component"))
            ) {
              return true;
            }
            if (
              node.querySelector &&
              node.querySelector(".bundly__component_grid_item, bundly-product-component-card, bundly-product-component")
            ) {
              return true;
            }
          }
          return false;
        });
        if (!shouldRefresh) return;
        window.clearTimeout(observer._t);
        observer._t = window.setTimeout(refresh, 80);
      });
      observer.observe(ctx.root, { childList: true, subtree: true });
    }

    window.addEventListener("load", function () {
      refresh();
      window.setTimeout(refresh, 250);
      window.setTimeout(refresh, 800);
      window.setTimeout(refresh, 1500);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
